import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;
    gap: 1rem;
`

export const SVGContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;
`

export const Title = styled.h3`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.75rem;
    color: ${({ theme }) => theme.colors.tfwBlack99};
    margin: 0;
`

export const Description = styled.p`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${({ theme }) => theme.colors.tfwBlack30};
    margin: 0;
    max-width: 25rem;
`

export const StyledButton = styled.button`
    margin-top: 0.5rem;
    padding: 0.75rem 1.5rem;
    border-radius: 0.75rem;
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1rem;
    cursor: pointer;
    text-align: center;
    border: 1px solid ${({ theme }) => theme.colors.tfwBlack99};
    background-color: ${({ theme }) => theme.colors.tfwWhite64};
    color: ${({ theme }) => theme.colors.tfwBlack99};

    &:hover {
        scale: 1.05;
    }

    &:active {
        transform: translateY(1px);
    }
`
